/**
 * Organizations picker — one call, one endpoint, group-scoped.
 *
 *   GET /api/v1/organizations/picker?group_id={group_id}
 *
 * Used by the TopNav OrgSelector for group-admin users to pick which
 * organization they are currently viewing. Agent-level pages read the
 * selected org id out of localStorage via useSelectedOrg below.
 */
import { apiGet } from "@shared/api/client";
import { pickerOrgsSchema } from "./orgs.schemas";
import type { PickerOrg } from "./orgs.schemas";

export const getPickerOrgs = (groupId: string): Promise<PickerOrg[]> =>
  apiGet(
    pickerOrgsSchema,
    `/organizations/picker?group_id=${encodeURIComponent(groupId)}`,
  );
